import { Box, Typography, Link, styled } from '@mui/material'
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent, timelineItemClasses } from '@mui/lab'
import { EpgResponse, OrderEventsProps } from '../../types/tracking'
import { formatDate } from '../../utils/format'

interface EventsProps {
    events: Array<OrderEventsProps>
    epg?: EpgResponse
}

const Events = ({ events = [], epg }: EventsProps) => {
    const reverseEventsArray = events.slice()

    if (epg) {
        reverseEventsArray.push({
            nombreEvento: epg.nombre,
            fecha: epg.nombre?.toLowerCase() !== 'aprobado' ? epg.date : null,
            nombreVisualizacionConsultoraEvento: epg.detalle,
            eventoTipoFinalizacionTracking: false,
        })
    }

    return (
        <Root>
            <TimelineStyled>
                {reverseEventsArray.map((event, index) => {
                    return (
                        <TimelineItem key={index} style={{ minHeight: index === reverseEventsArray.length - 1 ? 'auto' : undefined }}>
                            <TimelineOppositeContentStyled>
                                <Typography color="text.secondary" variant="body2">
                                    {event.fecha ? formatDate(event.fecha) : '-'}
                                </Typography>
                            </TimelineOppositeContentStyled>
                            <TimelineSeparator>
                                <TimelineDot
                                    variant={
                                        index === 0
                                            ? "filled"
                                            : "outlined"
                                    }
                                    color="primary"
                                />
                                { index < reverseEventsArray.length - 1 && (
                                    <TimelineConnectorStyled />
                                )}
                            </TimelineSeparator>
                            <TimelineContent>
                                <Typography variant="subtitle2" component="p">
                                    {event.nombreVisualizacionConsultoraEvento}
                                    { event.linkEvidencia && (
                                        <div>
                                            <Link href={event.linkEvidencia} target="_blank" variant="caption">
                                                Link evidencia
                                            </Link>
                                        </div>
                                    )}
                                    <TimelineContentMobileStyled>
                                        <Typography variant="body2" component="span">
                                            {event.fecha ? formatDate(event.fecha) : '-'}
                                        </Typography>
                                    </TimelineContentMobileStyled>
                                </Typography>
                            </TimelineContent>
                        </TimelineItem>
                    )
                })}
            </TimelineStyled>
        </Root>
    )
}

const Root = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
        borderRadius: theme.spacing(.5),
        border: `1px solid ${theme.palette.grey[200]}`
    }
}))

const TimelineStyled = styled(Timeline)(({ theme }) => ({
    padding: 0, 
    margin: 0,
    [theme.breakpoints.down('md')]: {
        [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0
        }
    }
}))

const TimelineOppositeContentStyled = styled(TimelineOppositeContent)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))

const TimelineContentMobileStyled = styled('span')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.down('md')]: {
        display: 'block'
    }
}))

const TimelineConnectorStyled = styled(TimelineConnector)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main
}))

export default Events
